export const DRILLS_SUBTOPICS_REQUEST = "DRILLS_SUBTOPICS_REQUEST";
export const DRILLS_SUBTOPICS_SUCCESS = "DRILLS_SUBTOPICS_SUCCESS";
export const  DRILLS_SUBTOPICS_FAILURE = "DRILLS_SUBTOPICS_FAILURE";